/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { AppState } from '@app/core/types';
import { createReducer, on } from '@ngrx/store';
import { billingMethods, removeCardOK } from './actions/billing-method.actions';

export const cardsReducer = createReducer<AppState['billingCards']>(
  [],
  on(billingMethods, (state, action) => action.data),
  on(removeCardOK, (state, action) => state.filter((c) => c.id !== action.cardId)),
);
